import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed, ref } from 'vue';
import { Field, DropdownField } from '@samc/centricity-core';
import { CountrySource, OrganizationCountrySource } from '@/Sources';


export default /*#__PURE__*/_defineComponent({
  __name: 'OldCountryDropdownField',
  props: {
    value: { type: String, required: false },
    label: { type: String, required: false, default: 'Country' },
    disabled: { type: Boolean, required: false, default: false },
    autoAssign: { type: Boolean, required: false, default: false },
    placeholder: { type: String, required: false },
    useOrganizationApi: { type: Boolean, required: false, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit: $emits }: { emit: ({ (event: 'input', value: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: string, label: string, disabled: boolean, autoAssign: boolean, placeholder?: string, useOrganizationApi: boolean };





const source = ref(props.useOrganizationApi === true ? new OrganizationCountrySource() : new CountrySource());

const val = computed({
  get: () => props.value ?? '',
  set: (value: string) => $emits('input', value)
});

return { __sfc: true,props, $emits, source, val, Field, DropdownField }
}

})